import React from 'react';
import { useLanguage } from '../context/LanguageContext';

/**
 * Generic skeleton primitives — Tailwind animate-pulse tabanlı.
 * Loading durumlarında spinner yerine içerik şekli gösterilir;
 * algılanan bekleme süresi azalır, layout zıplaması engellenir.
 */

export function Skeleton({ className = '', style }) {
  return (
    <div
      className={`bg-gray-200 dark:bg-gray-700 rounded animate-pulse ${className}`}
      style={style}
      aria-hidden="true"
    />
  );
}

export function SkeletonText({ lines = 1, className = '' }) {
  return (
    <div className={`space-y-2 ${className}`} aria-hidden="true">
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton
          key={i}
          className="h-3"
          style={{ width: `${100 - i * 12}%`, maxWidth: '100%' }}
        />
      ))}
    </div>
  );
}

/** Liste / tablo satırı için iskelet — tipik kart-stili satır */
export function SkeletonRow({ className = '' }) {
  return (
    <div className={`flex items-center gap-3 px-4 py-3 ${className}`} aria-hidden="true">
      <Skeleton className="h-9 w-9 rounded-full flex-shrink-0" />
      <div className="flex-1 min-w-0 space-y-1.5">
        <Skeleton className="h-3 w-1/3" />
        <Skeleton className="h-2.5 w-1/2" />
      </div>
      <Skeleton className="h-3 w-12 flex-shrink-0" />
    </div>
  );
}

/** Kart grid bileşeni için iskelet (örn. masa kartları, ürün kartları) */
export function SkeletonCard({ className = '' }) {
  return (
    <div
      className={`bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-3 space-y-2 ${className}`}
      aria-hidden="true"
    >
      <Skeleton className="h-2.5 w-2.5 rounded-full" />
      <Skeleton className="h-3 w-3/4" />
      <Skeleton className="h-2 w-1/2" />
    </div>
  );
}

/**
 * N adet satır/kart sarmalayıcı — bekleyen liste için pratik.
 * <SkeletonList count={6} variant="row" />
 */
export function SkeletonList({ count = 5, variant = 'row', className = '', wrapperClassName = '' }) {
  const { t } = useLanguage();
  const Item = variant === 'card' ? SkeletonCard : SkeletonRow;
  return (
    <div
      className={
        variant === 'card'
          ? `grid gap-2 ${wrapperClassName || ''}`
          : `divide-y divide-gray-100 dark:divide-gray-700/50 ${wrapperClassName || ''}`
      }
      style={variant === 'card' ? { gridTemplateColumns: 'repeat(auto-fill, minmax(110px, 1fr))' } : undefined}
      role="status"
      aria-label={t('loading') || 'Yükleniyor...'}
    >
      {Array.from({ length: count }).map((_, i) => (
        <Item key={i} className={className} />
      ))}
    </div>
  );
}

const SkeletonPrimitives = { Skeleton, SkeletonText, SkeletonRow, SkeletonCard, SkeletonList };
export default SkeletonPrimitives;
